module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-wood-rovere-safari.5d6135a5.jpg";